import MainLayout from "./components/MainLayout";
import Main from './components/Main';
import Agencias from './components/Agencias'
import Solicitud from './pages/Solicitud'
import ListaSolicitudes from './pages/ListaSolicitudes'
import Campeonato from './pages/Campeonato'
import Empresas from "./pages/Empresas";
import Certificado from "./pages/Certificado";

const routes = [
  {
    path: '/crdasczX',
    element: <MainLayout />,
    children: [
      { path: '/asociados', element: <Main /> },
      { path: '/agencias', element: <Agencias /> },
      { path: '/solicitud', element: <Solicitud /> },
      { path: '/lista_solicitudes', element: <ListaSolicitudes /> },
      { path: '/campeonato', element: <Campeonato /> },
      { path: '/empresas', element: <Empresas /> },
      { path: '/certificado/:id', element: <Certificado /> },
    ]
  }
];

export default routes;
